
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EcCountry } from '../../../../classes/country';
import { EbPslApp } from '../../../../classes/pslApp';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TTEvent } from '../../../../classes/tTEvent';
import { EbTtCategorieDeviation } from '../../../../classes/categorieDeviation';
import { Statique } from '../../../../utils/statique';
import { MTEnum } from '../../../../classes/mtEnum';
import { EnumPsl } from '../../../../utils/enumeration';
import { StatiqueService } from '../../../../services/statique.service';

@Component({
	selector: 'app-modal-event',
	templateUrl: './modal-event.component.html',
	styleUrls: ['../../../../shared/modal/modal.component.css', './modal-event.component.css']
})
export class ModalEventComponent implements OnInit {

    @Input() readOnly?: boolean;
    @Input() listPsl?: Array<MTEnum>;
    @Input() listCountry: Array<EcCountry>;
    @Input()
    set ebPslApp(pslApp: EbPslApp){
        this.ebPslAppValue = pslApp;
        if(pslApp && pslApp.xEcCountry && pslApp.xEcCountry.ecCountryNum)
            this.ecCountry = pslApp.xEcCountry;
        else
            this.ecCountry = null;
    }
    @Input() listCategorieDeviation: Array<EbTtCategorieDeviation>;
    @Input() ttEvent: TTEvent = new TTEvent();
    @Output() confirmEventHandler: EventEmitter<Object> = new EventEmitter();

    ebPslAppValue: EbPslApp;
    ecCountry: EcCountry;
    listDeviationCategorie: Array<MTEnum> = new Array<MTEnum>();

    EnumPsl = EnumPsl;
    read: Boolean = true;

	constructor(public activeModal: NgbActiveModal,private statiqueService: StatiqueService,
    ) {
	}

	ngOnInit() {
        if(this.listCountry.length <= 0 )
            this.getStatiques();
        
        if(typeof this.readOnly == "undefined")
            this.readOnly = true;
        if(typeof this.listPsl == "undefined")
            this.listPsl = null;

        if(this.ttEvent){
            this.listDeviationCategorie = Statique.TtDeviationCategorie.map(it => {
                let dev = new MTEnum();
                dev.code = it.key;
                dev.libelle = it.value;
                return dev;
            });
        }
    }
    
    
    confirmModalAddEvent(){
        if(this.ebPslAppValue)
            this.ebPslAppValue.xEcCountry = this.ecCountry;
        this.confirmEventHandler.emit({ebPslApp: this.ebPslAppValue, ttEvent: this.ttEvent});
    }
    cancelModalAddEvent(){
        this.ebPslAppValue = null;
        this.ttEvent = null;
    }
    
    compareCountry(country1: EcCountry, country2: EcCountry) {
		if (country2 !== undefined && country2 !== null) {
			return country1.ecCountryNum === country2.ecCountryNum;
		}
    }
    compareCategory(mtEnum1: MTEnum, mtEnum2: MTEnum) {
		if (mtEnum2 !== undefined && mtEnum2 !== null) {
			return mtEnum1.code === mtEnum2.code;
		}
    }

    getStatiques() {
        this.statiqueService.getListPays().subscribe(data => {
            this.listCountry = data;
        });
        this.statiqueService.getListCategorieDeviation().subscribe(data => {
            this.listCategorieDeviation = data;
        });
    }
    
    /* pslfunction(){
        if(this.ebPslAppValue.codePsl!=null){
            if(this.ebPslAppValue.codePsl.code==EnumPsl.DOUANE || this.ebPslAppValue.codePsl.code==EnumPsl.DELIVERY){
            return this.read=false;}
            else
            return this.read=true;
        }
        return this.read=true;
    } */
   /*  countryRequiredPsl(){
        if(this.ebPslAppValue.codePsl!=null){
            if(this.ebPslAppValue.codePsl.code==EnumPsl.DELIVERY ){
            return this.read=false;}
            else
            return this.read=true;
        }
        return this.read=true;
    } */

}



// WEBPACK FOOTER //
// ./src/app/component/track-trace/shared-components/modal-event/modal-event.component.ts